import routes from './routes/index'
import store from './store/index'
import App from './App'

export { routes, store, App }



// WEBPACK FOOTER //
// ./src/app/index.js